import React, { useEffect, useState, useRef } from "react";
import "./Advertisement.css";
import { ref, listAll, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebase";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

const Advertisement = () => {
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const swiperRef = useRef(null);
  const videoRefs = useRef([]); // Store references to video elements
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    const fetchMedia = async (path, setState) => {
      try {
        const storageRef = ref(storage, path);
        const result = await listAll(storageRef);
        const urlPromises = result.items.map((mediaRef) =>
          getDownloadURL(mediaRef)
        );
        const urls = await Promise.all(urlPromises);
        setState(urls);
      } catch (error) {
        console.error(`Error fetching ${path}:`, error);
      }
    };

    fetchMedia("Advertisements", setImages); // Fetch images
    fetchMedia("Advertisements-video", setVideos); // Fetch videos

    const handleVideoPlay = (swiper) => {
      // Stop autoplay when video starts playing
      if (swiper?.autoplay) {
        swiper.autoplay.stop();
      }
    };
  }, []);

  const handleVideoPlay = (swiper) => {
    // Stop autoplay when video starts playing
    if (swiper?.autoplay) {
      swiper.autoplay.stop();
    }
  };

  const handleVideoEnd = (swiper) => {
    // Automatically move to the next slide when the video ends
    if (swiper?.autoplay) {
      swiper.slideNext(); // Move to the next slide
      swiper.autoplay.start(); // Restart autoplay after video ends
    }
  };

  const handleSwiperInit = (swiper) => {
    swiperRef.current = swiper;
    // Automatically play the video on the first slide
    const firstSlide = swiper.slides[swiper.activeIndex];
    if (firstSlide) {
      const videoElement = firstSlide.querySelector("video");
      if (videoElement) {
        videoElement.play(); // Play video on the first slide
      }
    }
  };

  const openLightbox = (src) => {
    setSelectedImage(src);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const handleSlideChange = (swiper) => {
    if (!swiper || !swiper.slides) return; // Ensure swiper and slides exist
    const currentSlide = swiper.slides[swiper.activeIndex];
    if (currentSlide) {
      const videoElement = currentSlide.querySelector("video");
      if (videoElement) {
        videoElement.play(); // Play video on the current slide
      }
    }
  };
  return (
    <div className="advertisement-divider-container">
      <div className="advertisement-divider top"></div>
      <div className="advertisement-content">
        <div className="advertisement-section">
          <div className="donation-title">
            <h4>ADVERTISEMENT</h4>
            <div className="title-underline-donation"></div>
          </div>

          {/* Image Swiper */}
          <div className="advertisement-images-container">
            <Swiper
              spaceBetween={20}
              slidesPerView={1}
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              breakpoints={{
                768: {
                  slidesPerView: 1,
                },
                1200: {
                  slidesPerView: 2,
                },
              }}
              modules={[Pagination, Navigation, Autoplay]}
            >
              {images.map((image, index) => (
                <SwiperSlide key={index}>
                  <div className="advertisement-image-container" onClick={() => openLightbox(image)}>
                    <img
                      src={image}
                      alt={`Advertisement ${index + 1}`}
                      className="advertisement-image"
                    />
                  </div>
                </SwiperSlide>
              ))}

{selectedImage && (
        <div className="lightbox-add" onClick={closeLightbox}>
          <div className="lightbox-content">
            <img src={selectedImage} alt="Enlarged" />
          </div>
        </div>
      )}
            </Swiper>
          </div>

          {/* Video Swiper */}
          

          
          
        </div>
      </div>

      <div className="advertisement-videos">
  {videos.map((video, index) => (
    <div
      className="advertisement-video-container"
      key={index}
      style={{ display: video ? "block" : "none" }}
    >
      <video
        src={video}
        muted
        autoPlay
        loop
        className="advertisement-video"
      />
    </div>
  ))}
</div>
    </div>
  );
};

export default Advertisement;
